import { render } from "./pay-salary.vue?vue&type=template&id=60f08134"
import script from "./pay-salary.vue?vue&type=script&lang=js"
export * from "./pay-salary.vue?vue&type=script&lang=js"

import "./pay-salary.vue?vue&type=style&index=0&id=60f08134&lang=css"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__